module.exports = __webpack_public_path__ + "static/img/yuanxing.f049289.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/yuanxing.png
// module id = r80B
// module chunks = 1